import { ProviderFormProvider } from '@pages/Fabric/common/ProviderFormContext';

import { UnifiedBigQueryForm } from '../../../../Fabric/unifiedFabrics/bigquery/UnifiedBigQueryForm';
import { BigQueryReadOnlyView } from './BigQueryReadOnlyView';

export const BigQuerySetupForm = ({ isReadonly }: { isReadonly: boolean }) => {
  if (isReadonly) {
    return <BigQueryReadOnlyView />;
  }

  return (
    <ProviderFormProvider isOrchestrationFabric={false}>
      <UnifiedBigQueryForm />
    </ProviderFormProvider>
  );
};
